import { StepProps } from "../../components/Stepper"
import { Movie, MovieSession } from "../entities/movie"
import { Place } from "../entities/session"
import { StepsData } from "./steps"

export type BuyRouteState = {
    sessionId: number
    movieData: { poster: string; poster_mobile: string; privileges: Movie["privileges"] }
    sessions: Movie["sessions"]
}

export function isBuyRouteState(state: unknown): state is BuyRouteState {
    if (!state || typeof state !== "object") return false
    const value = state as Partial<BuyRouteState>
    return (
        typeof value.sessionId === "number" &&
        Boolean(value.movieData) &&
        Array.isArray(value.sessions) &&
        value.sessions.length > 0
    )
}

export interface BuyData extends StepsData {
    session: MovieSession
    movieData: { poster: string; poster_mobile: string; privileges: Movie["privileges"] }
    payInfo: PayInfo
    resOrder?: ResOrder
    qrImage?: string
    orderNumber?: string
    orderId: ResOrder["id"]
    orderCreatedAt?: string
    orderExpiredAt?: string
    sbpBanks?: SbpBank[]
    paymentRedirectUrl?: string
}

export type SbpBank = {
    bank_name: string
    logo_url: string
    iosUrl: string
    androidUrl: string
}

export type SbpPaymentResponse = {
    order_number: string
    redirect_url?: string
    qrImage?: string
    sbp_banks?: SbpBank[]
}

export type PayInfo = {
    selectedSeats: Place[]
    film_name?: string
    description?: string
    format?: string
    totalPrice: number
    selectedSession: string | number
    privileges: Movie["privileges"]
    poster: string
    poster_mobile: string
    other: {
        cinemaName?: string
        hallNumber?: string | number
        date: string | null
        time?: string
    }
}

export type PaymentsProps = {
    payInfo: PayInfo
    orderBody: {
        seats: number[]
        bonus_pay: number
        phone?: string
        email?: string
    }
    proceed?: {
        data: {
            pushkin_card: object
        }
    }
    navigate: StepProps<BuyData>["navigate"]
}

export type PaymentMethod = {
    type: string
    label: string
}

type PaymentProvider = "card" | "apple" | "google" | "sberpay" | "sbp" | "pushkin_card"

type PaymentMethodInfo = {
    name: string
    merchant_id?: string
    bank_merchant_id?: string
    environment?: "PRODUCTION" | "TEST"
}

type PaymentMethods = {
    card?: PaymentMethodInfo
    apple?: PaymentMethodInfo
    google?: PaymentMethodInfo
    sberpay?: PaymentMethodInfo
    sbp?: PaymentMethodInfo
    pushkin_card?: PaymentMethodInfo
}

type Payment = {
    provider: PaymentProvider
    methods: PaymentMethods
}

type Amount = {
    all: number
    pay: number
    bonus_add: number
    bonus_pay: number
}

type Cinema = {
    id?: number
    name: string
}

type Hall = {
    id?: number
    name: string | number
}

type OrderStatus = {
    id: number
    name: string
}

type ResOrder = {
    id: string
    code: string
    number: string
    amount: Amount
    description?: PayInfo["description"]
    film_name?: PayInfo["film_name"]
    poster: PayInfo["poster"]
    poster_mobile: PayInfo["poster_mobile"]
    privileges: PayInfo["privileges"]
    seats: Place[]
    session: MovieSession
    cinema: Cinema
    hall: Hall
    payment: Payment
    status: OrderStatus
    created_at: string
    expired_at: string
}

export type CreatedOrder = {
    id: string
    code: string
    number: string
    amount: Amount
    cinema: Cinema
    cinema_id: number
    hall: Hall
    session: MovieSession
    film: {
        name: string
        poster_mobile: {
            big: string
            small: string
        }
    }
    seats: Place[]
    payment: Payment
    payment_info: {
        method_id: number
        method_slug: string
        fio: string
    }
    status: {
        id: number
        name: string
    }
    description?: string
    comment?: {
        add: boolean
        text: string | null
    }
    created_at: string
    expired_at: string
}

// type Bank = {
//     bank_name: string
//     logo_url: string
//     iosUrl: string
//     androidUrl: string
// }

// export type SbpPayment = {
//     id: string
//     order_number: string
//     redirect_url: string
//     sbp_banks: Bank[]
// }
